import React from 'react';

import companyLogo from 'asset/SoftServe-logo.svg';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="gl-wrapper">
      <div className="flex min-h-11 items-center justify-between gap-5 sm:flex-col sm:items-start sm:justify-center sm:gap-4">
        <a href="https://softserveinc.com" target="_blank" without rel="noreferrer">
          <img width={111} height={19} className="h-[1.1875rem] w-[6.9375rem]" src={companyLogo} alt="SoftServe logo" />
        </a>
        <p className="min-h-[19px] text-white sm:flex sm:items-center">© Copyright {currentYear} SoftServe Inc.</p>
      </div>
    </div>
  );
}
